import GlassCard from '@/components/GlassCard';
import useInertiaData from '@/hooks/useInertiaData';
import React from 'react';
import AccountDetails from './Partials/AccountDetails';
import DiscordConnection from './Partials/DiscordConnection';
import PasswordChange from './Partials/PasswordChange';

const Profile: React.FC = () => {
    const { enabled_integrations = [] } = useInertiaData();

    return (
        <div className="mx-auto max-w-4xl">
            <GlassCard className="shadow-lg">
                <AccountDetails />
                {enabled_integrations.includes('discord') ? <DiscordConnection /> : null}
                <PasswordChange />
            </GlassCard>
        </div>
    );
};

export default Profile;
